/**
 * Pure helpers for packing list stats (item count, trailer names by category).
 * Used by CreateTripDialog, EditTripDialog, CreateOperationDialog.
 */

import type { PackingListItemMinimal } from '../schema';

export function getPackingListStats(
    packingListItemsByEvent: Map<string, PackingListItemMinimal[]>,
    eventId: string
): { itemCount: number; trailerNames: string[] } {
    const items = packingListItemsByEvent.get(eventId) ?? [];
    const trailerNames = new Set<string>();
    for (const item of items) {
        const cat = item.itemType?.category?.name ?? '';
        if (cat === 'Trailers' && item.itemType?.name) {
            trailerNames.add(item.itemType.name);
        }
    }
    return { itemCount: items.length, trailerNames: Array.from(trailerNames) };
}
